// extracted by mini-css-extract-plugin
export default {"navigation":"navigation_navigation__9wZLg","navigation__container":"navigation_navigation__container__WyKo9"};